import React, { createContext, useContext, useEffect, useState } from 'react';

// Site configuration - Le Golf de Songon M'braté only
export const SITES = {
  GOLF: {
    id: 'golf',
    name: 'Le Golf de Songon Mbraté',
    tagline: 'Parcours de prestige',
    domains: ['legolfdesongon.com', 'www.legolfdesongon.com', 'localhost', '127.0.0.1'],
    primaryColor: 'emerald',
    logo: 'LGS',
    externalUrl: 'https://legolfdesongon.com'
  }
};

// Context
const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const [currentSite, setCurrentSite] = useState(SITES.GOLF);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setCurrentSite(SITES.GOLF);
    setIsLoading(false);
    document.title = SITES.GOLF.name;
  }, []);

  const value = {
    currentSite,
    setCurrentSite,
    isLoading,
    isGolf: true,
    allSites: SITES
  };

  return (
    <SiteContext.Provider value={value}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => {
  const context = useContext(SiteContext);
  if (!context) {
    throw new Error('useSite must be used within a SiteProvider');
  }
  return context;
};

export default SiteContext;
